/**
 * Adapted from Feather Icons "truck" (https://feathericons.com, ISC license),
 * rescaled to the 16x16 grid.
 */
export function TruckIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      aria-label="Truck"
      focusable="false"
    >
      <rect
        x="0.67"
        y="2"
        width="10"
        height="8.67"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="10.67 5.33 13.33 5.33 15.33 7.33 15.33 10.67 10.67 10.67 10.67 5.33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="3.67"
        cy="12.33"
        r="1.67"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12.33"
        cy="12.33"
        r="1.67"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
